import { render, staticRenderFns } from "./SignPannel.vue?vue&type=template&id=65f9405b&scoped=true"
import script from "./SignPannel.vue?vue&type=script&lang=js"
export * from "./SignPannel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65f9405b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Test-OA/jh-oa-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65f9405b')) {
      api.createRecord('65f9405b', component.options)
    } else {
      api.reload('65f9405b', component.options)
    }
    module.hot.accept("./SignPannel.vue?vue&type=template&id=65f9405b&scoped=true", function () {
      api.rerender('65f9405b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/officeApproval/common/form/components/SignPannel.vue"
export default component.exports